import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const CardList = ({
  children,
  empty,
}: {
  children: ReactNode;
  empty?: boolean;
}) => {
  return (
    <div
      className={cn(
        "flex h-full flex-col gap-4 py-4",
        empty && "justify-center",
      )}
    >
      {children}
    </div>
  );
};
